import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import _Object$keys from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/object/keys";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.regexp.to-string";
import _JSON$stringify from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/json/stringify";
import "core-js/modules/es6.regexp.replace";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import { getLang, getUUid } from "../utils/apiHelper";
import * as constants from "./constants";
import HttpClient from "../http/index";

var CryptoJS = require("crypto-js");

import { clientError } from "@/api/utils/apiHelper";

var ZMClient =
/*#__PURE__*/
function () {
  function ZMClient() {
    _classCallCheck(this, ZMClient);
  }

  _createClass(ZMClient, [{
    key: "safeUrl",
    value: function safeUrl(str) {
      // "+" => "-", "/" => "_", "=" => ""
      str = str.replace(/\+/g, "-");
      str = str.replace(/\//g, "_");
      str = str.replace(/\=/g, "");
      return str;
    }
  }, {
    key: "requestCommonFactory",
    value: function requestCommonFactory() {
      var vision = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var methods = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "GET";
      var req = {};
      req.headers = {};
      req.headers["User-Agent"] = constants.UA;
      var baseURL = constants.BASE_URL;

      if (vision) {
        baseURL = constants.BASE_URL_VISION;
      }

      req.baseURL = baseURL;
      var client = {};
      client.channel = 200;
      client.country = getLang(); // 该值应该跟随真机,这里只给出默认值

      client.system_version_name = "12.1.3"; // 该值应该跟随真机,这里只给出默认值

      client.dtype = 2;

      if (vision) {
        client.did = this.deviceId;
        client.app_version_number = constants.APP_BUILD_VERSION;
      } else {
        client.aid = this.deviceId;
        client.app_version = constants.APP_BUILD_VERSION;
      }

      client.lang = this.language;
      client.package_name = constants.BUNDEL_ID;
      console.log("client:", client);
      var stringUtf = CryptoJS.enc.Utf8.parse(_JSON$stringify(client)); // console.log('stringUtf',stringUtf)

      var base64string = CryptoJS.enc.Base64.stringify(stringUtf); // console.log("base64string:", base64string);

      var safeUrlRes = this.safeUrl(base64string);

      if (methods === "GET") {
        req.params = {};
        req.params.api_key = constants.API_KEY;
        req.params.client_lang = this.language;
        req.params.timestamp = Math.floor(new Date().getTime() / 1000).toString();

        if (vision) {
          req.params.device = safeUrlRes;
        } else {
          req.params.client = safeUrlRes;
        }
      } else {
        req.data = {};
        req.data.api_key = constants.API_KEY;
        req.data.client_lang = this.language;
        req.data.timestamp = Math.floor(new Date().getTime() / 1000).toString();

        if (vision) {
          req.data.device = safeUrlRes;
        } else {
          req.data.client = safeUrlRes;
        }
      }

      return req;
    }
  }, {
    key: "sortQuery",
    value: function sortQuery(req) {
      var params = req.params;
      var keys = [];

      var _arr = _Object$keys(params);

      for (var _i = 0; _i < _arr.length; _i++) {
        var key = _arr[_i];
        keys.push(key);
      }

      keys.sort(); // 字典排序

      var pairs = [];

      for (var _i2 = 0; _i2 < keys.length; _i2++) {
        var _key = keys[_i2];
        pairs.push("".concat(_key, "=").concat(params[_key]));
      }

      var paramsString = pairs.join("&"); // console.log("paramsString:", paramsString);

      delete req.params;
      return "?" + paramsString;
    }
  }, {
    key: "signRequestHeaders",
    value: function signRequestHeaders(req) {
      // req.params 是一个Object,在序列化时应采用name的字典排序
      var keys = [];

      var _arr2 = _Object$keys(req.params);

      for (var _i3 = 0; _i3 < _arr2.length; _i3++) {
        var key = _arr2[_i3];
        keys.push(key);
      }

      keys.sort(); // 字典排序

      var pairs = [];

      for (var _i4 = 0; _i4 < keys.length; _i4++) {
        var _key2 = keys[_i4];
        pairs.push("".concat(_key2, "=").concat(req.params[_key2]));
      }

      var paramsString = pairs.join("&"); // console.log("signRequestHeaders paramsString:", paramsString);

      var str = [req.method, req.path, paramsString, ""].join("\n"); // console.log("str:", str);
      // 请自行引入HmacSHA256算法

      str = CryptoJS.HmacSHA256(str, constants.SECRET_KEY); // hash后直接对Buffer的数据进行base64,不要进行十六进制编码
      // console.log("str:", str);

      str = CryptoJS.enc.Base64.stringify(str); // console.log("str:", str);

      str = this.safeUrl(str); // console.log("str:", str);

      req.headers["Authorization"] = str;
      return;
    } // 检测脸,image_key格式:face/XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX-XXXX-XXXXXXXXXXXXXXXX
    // 注意image_key的后面串不是单纯的uuid,在iOS端是通过NSProcessInfo.processInfo.globallyUniqueString生成的

  }, {
    key: "req_face_detect",
    value: function req_face_detect(type, image_key) {
      var _this = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(resolve, reject) {
          var req, query, res;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  req = _this.requestCommonFactory(true, "GET");
                  req.method = "GET";
                  req.path = constants.FACE_DETECT;
                  req.params.bucket = constants.BUCKET;
                  req.params.type = type.toString();
                  req.params.image = image_key;
                  req.params.type = type.toString();

                  _this.signRequestHeaders(req);

                  console.log("req_face_detect requ:", req);
                  query = _this.sortQuery(req);
                  _context.next = 13;
                  return HttpClient.get(constants.BASE_URL_VISION + constants.FACE_DETECT + query, req);

                case 13:
                  res = _context.sent;
                  resolve(res);
                  _context.next = 21;
                  break;

                case 17:
                  _context.prev = 17;
                  _context.t0 = _context["catch"](0);
                  reject(_context.t0);
                  clientError("req_face_detect", _context.t0);

                case 21:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 17]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }()); // commit
    } // 时光相机
    // 先通过AWS上传图片,再请求req_face_detect(3)
    // face_rect 来自 res.faces[0].face_rectangle
    // ethnicity,gender 来自 res.faces[0].attributes

  }, {
    key: "req_aging_shutter",
    value: function req_aging_shutter(image_key, ethnicity, gender, face_rect) {
      var _this2 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref2 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee2(resolve, reject) {
          var req, ethnicity_enum, gender_enum, query, res;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  req = _this2.requestCommonFactory();
                  req.method = "GET";
                  req.path = constants.AGING_SHUTTER;
                  req.params.bucket = constants.BUCKET;
                  ethnicity_enum = 0;
                  _context2.t0 = ethnicity;
                  _context2.next = _context2.t0 === "ASIAN" ? 9 : _context2.t0 === "BLACK" ? 11 : _context2.t0 === "WHITE" ? 13 : 15;
                  break;

                case 9:
                  ethnicity_enum = 1;
                  return _context2.abrupt("break", 15);

                case 11:
                  ethnicity_enum = 2;
                  return _context2.abrupt("break", 15);

                case 13:
                  ethnicity_enum = 3;
                  return _context2.abrupt("break", 15);

                case 15:
                  gender_enum = 0;
                  _context2.t1 = gender;
                  _context2.next = _context2.t1 === "Male" ? 19 : _context2.t1 === "Female" ? 21 : 23;
                  break;

                case 19:
                  gender_enum = 1;
                  return _context2.abrupt("break", 23);

                case 21:
                  gender_enum = 2;
                  return _context2.abrupt("break", 23);

                case 23:
                  req.params.ethnicity = ethnicity_enum.toString();
                  req.params.gender = gender_enum.toString();
                  req.params.image = image_key;
                  req.params.rate1 = "65";
                  req.params.rate2 = "65";
                  req.params.rate3 = "65";
                  req.params.rectangle = encodeURIComponent("".concat(face_rect.top, ",").concat(face_rect.left, ",").concat(face_rect.width, ",").concat(face_rect.height));

                  _this2.signRequestHeaders(req);

                  query = _this2.sortQuery(req);
                  console.log("req_aging_shutter req:", req);
                  _context2.next = 35;
                  return HttpClient.get(constants.BASE_URL_VISION + constants.AGING_SHUTTER + query, req);

                case 35:
                  res = _context2.sent;
                  resolve(res);
                  _context2.next = 44;
                  break;

                case 39:
                  _context2.prev = 39;
                  _context2.t2 = _context2["catch"](0);
                  console.log("req_aging_shutter error", _context2.t2);
                  reject(_context2.t2);
                  clientError("req_aging_shutter", _context2.t2);

                case 44:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[0, 39]]);
        }));

        return function (_x3, _x4) {
          return _ref2.apply(this, arguments);
        };
      }()); // commit
    } // 性别转换
    // 先通过AWS上传图片,再请求req_face_detect(3)
    // face_rect 来自 res.faces[0].face_rectangle
    // ethnicity,gender 来自 res.faces[0].attributes
    // type 1=Business 2=Leisure 3=Student
    // 返回的数据是base64的图片

  }, {
    key: "req_gender_switch",
    value: function req_gender_switch(image_key, ethnicity, gender, face_rect, type) {
      var _this3 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref3 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee3(resolve, reject) {
          var req, ethnicity_enum, gender_enum, query, res;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.prev = 0;
                  req = _this3.requestCommonFactory();
                  req.method = "GET";
                  req.path = constants.GENDER_SWITCH;
                  req.params.bucket = constants.BUCKET;
                  ethnicity_enum = 0;
                  _context3.t0 = ethnicity;
                  _context3.next = _context3.t0 === "ASIAN" ? 9 : _context3.t0 === "BLACK" ? 11 : _context3.t0 === "WHITE" ? 13 : 15;
                  break;

                case 9:
                  ethnicity_enum = 1;
                  return _context3.abrupt("break", 15);

                case 11:
                  ethnicity_enum = 2;
                  return _context3.abrupt("break", 15);

                case 13:
                  ethnicity_enum = 3;
                  return _context3.abrupt("break", 15);

                case 15:
                  req.params.ethnicity = ethnicity_enum.toString();
                  gender_enum = 0;
                  _context3.t1 = gender;
                  _context3.next = _context3.t1 === "Male" ? 20 : _context3.t1 === "Female" ? 22 : 24;
                  break;

                case 20:
                  gender_enum = 2;
                  return _context3.abrupt("break", 24);

                case 22:
                  gender_enum = 1;
                  return _context3.abrupt("break", 24);

                case 24:
                  req.params.gender = gender_enum.toString();
                  req.params.image = image_key;
                  req.params.mergeRate = "65";
                  req.params.rectangle = encodeURIComponent("".concat(face_rect.top, ",").concat(face_rect.left, ",").concat(face_rect.width, ",").concat(face_rect.height));
                  req.params.type = type.toString();

                  _this3.signRequestHeaders(req);

                  query = _this3.sortQuery(req);
                  _context3.next = 33;
                  return HttpClient.get(constants.BASE_URL_VISION + constants.GENDER_SWITCH + query, req);

                case 33:
                  res = _context3.sent;
                  resolve(res);
                  _context3.next = 41;
                  break;

                case 37:
                  _context3.prev = 37;
                  _context3.t2 = _context3["catch"](0);
                  reject(_context3.t2);
                  clientError("req_gender_switch", _context3.t2);

                case 41:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[0, 37]]);
        }));

        return function (_x5, _x6) {
          return _ref3.apply(this, arguments);
        };
      }()); // commit
    } // 爱情匹配
    // sign1,sign2 为星座序号,白羊座=0

  }, {
    key: "req_love_compatibility",
    value: function req_love_compatibility(sign1, sign2) {
      var _this4 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref4 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee4(resolve, reject) {
          var req, res;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.prev = 0;
                  req = _this4.requestCommonFactory(false, "GET");
                  req.method = "GET";
                  req.path = constants.LOVE_COMPATIBILITY;
                  req.params.sign1 = sign1;
                  req.params.sign2 = sign2;

                  _this4.signRequestHeaders(req);

                  console.log("req_love_compatibility requ:", req);
                  _context4.next = 10;
                  return HttpClient.get(constants.BASE_URL + constants.LOVE_COMPATIBILITY, req);

                case 10:
                  res = _context4.sent;
                  resolve(res);
                  _context4.next = 18;
                  break;

                case 14:
                  _context4.prev = 14;
                  _context4.t0 = _context4["catch"](0);
                  reject(_context4.t0);
                  clientError("req_love_compatibility", _context4.t0);

                case 18:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, null, [[0, 14]]);
        }));

        return function (_x7, _x8) {
          return _ref4.apply(this, arguments);
        };
      }()); // commit
    } // 星座匹配
    // sign1,sign2 为星座序号,白羊座=0

  }, {
    key: "req_zodiac_compatibility",
    value: function req_zodiac_compatibility(sign1, sign2) {
      var _this5 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref5 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee5(resolve, reject) {
          var req, res;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.prev = 0;
                  req = _this5.requestCommonFactory(false, "GET");
                  req.method = "GET";
                  req.path = constants.ZODIAC_COMPATIBILITY;
                  req.params.sign1 = sign1;
                  req.params.sign2 = sign2;

                  _this5.signRequestHeaders(req);

                  console.log("req_zodiac_compatibility:", req);
                  _context5.next = 10;
                  return HttpClient.get(constants.BASE_URL + constants.ZODIAC_COMPATIBILITY, req);

                case 10:
                  res = _context5.sent;
                  resolve(res);
                  _context5.next = 18;
                  break;

                case 14:
                  _context5.prev = 14;
                  _context5.t0 = _context5["catch"](0);
                  reject(_context5.t0);
                  clientError("req_zodiac_compatibility", _context5.t0);

                case 18:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, null, [[0, 14]]);
        }));

        return function (_x9, _x10) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "language",
    get: function get() {
      return getLang();
    }
  }, {
    key: "deviceId",
    get: function get() {
      return getUUid();
    }
  }]);

  return ZMClient;
}();

export default new ZMClient();